import React from 'react';
const LotProperty = ({ icon, measure, value }) => {
    return (React.createElement("div", { className: "lot-property" },
        icon && React.createElement("div", { className: "lot-property__icon" }, icon),
        value && React.createElement("div", { className: "lot-property__value" }, value),
        measure && React.createElement("div", { className: "lot-property__measure" },
            "\u00A0",
            measure)));
};
export default React.memo(LotProperty);
